const showCookies = () => {

	let notDeprive = document.querySelector('.not-deprive'),
		cookies = document.querySelector('.cookies');

	let cookieDate = localStorage.getItem('cookieDate');
    let cookieNotification = document.getElementById('cookie_notification');
    let cookieBtn = cookieNotification.querySelector('.cookie_accept');

    localStorage.setItem('number', 20);
    //console.log( Date.now() );


    // Если записи про кукисы нет или она просрочена на 1 год, то показываем информацию про кукисы
    if( !cookieDate || (+cookieDate + 31536000000) < Date.now() ){ 
        cookieNotification.classList.remove('hide');       
        cookieNotification.classList.add('show-flex');
    }

    // При клике на кнопку, в локальное хранилище записывается текущая дата в системе UNIX
    cookieBtn.addEventListener('click', function(){

        localStorage.setItem( 'cookieDate', Date.now() );
        cookieNotification.classList.remove('show-flex');
        cookieNotification.classList.add('hide');
    })
}
export default showCookies;